// extracted by mini-css-extract-plugin
module.exports = {"link":"_4e5f713ae4--link--f9qmJ","link-name":"_4e5f713ae4--link-name--t_Evz"};